const sortBySetter =
  (key: string, descend?: boolean) =>
  (a: { [x: string]: number }, b: { [x: string]: number }): number => {
    if (a[key] < b[key]) {
      return descend ? 1 : -1
    }
    if (a[key] > b[key]) {
      return descend ? -1 : 1
    }
    return 0
  }

export default sortBySetter
